// extracted by mini-css-extract-plugin
module.exports = {"form":"Register_form__19vOb","segment":"Register_segment__1ANzT","number":"Register_number__zOqKR","inputs":"Register_inputs__2Pd8s"};